import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import * as actions from './actions'
import * as api from './api'
import { reduxActionCount, createMetric } from 'app/modules/driftAppMetrics/helper'
import { orgId } from 'app/modules/org/selectors'
import * as SocketConstants from 'app/modules/socket/constants'

const MINUTE = 60 * 1000

const sendDriftAppMetric$ = (action$) => {
  return action$
    .ofType(actions.sendDriftAppMetric.toString())
    .pluck('payload')
    .mergeMap((metric) =>
      api.sendDriftAppMetric(metric)
        .map(() => actions.sendDriftAppMetricSuccess())
        .startWith(actions.sendDriftAppMetricPending())
        .catch(error => Observable.of(actions.sendDriftAppMetricFailed(error))))
}

let actionCount = 0
const countAllActions$ = (action$, { getState }) => {
  return action$
    .filter(() => orgId(getState()) === 1)
    .do(() => actionCount++)
    .mergeMap(() => Observable.empty())
}

const dispatchMetricInterval$ = (action$, { getState }) => {
  return Observable
    .interval(MINUTE)
    .filter(() => orgId(getState()) === 1)
    .map(() => {
      const actionCountToDispatch = actionCount
      actionCount = 0
      return actions.sendDriftAppMetric((reduxActionCount(actionCountToDispatch)))
    })
}

const getTrackPresenceLoadTimePayload = (startTime, getState) => {
  const endTime = Date.now()
  const loadTime = endTime - startTime
  if (__ENV__ !== 'PRODUCTION') {
    console.debug(`__DRIFT__: Took ${loadTime}ms to load presence state`)
  }

  const metric = createMetric('customer-web.liveSocketTime.buckets', {
    type: 'bootstrap.total',
    org_1: orgId(getState()) === 1
  })

  return {
    value: loadTime,
    dimensions: {
      type: 'bucket',
      buckets: "500, 1000, 2000, 5000, 15000"
    },
    metric,
  }
}

const recordBootstrapPerformance$ = action$ =>
  action$
    .ofType(actions.enterRootAppRoute.toString())
    .first()
    .map(() => {
      const checkpoint = {
        label: 'enterRootAppRoute',
        timestamp: Date.now(),
      }

      const bootstrapCheckpoints = [...window.__DRIFT__bootstrapCheckpoints, checkpoint]

      if (__ENV__ !== 'PRODUCTION') {
        for (let i = 0; i < bootstrapCheckpoints.length; i++) {
          const previousCheckpoint = bootstrapCheckpoints[i - 1]
          const currentCheckpoint = bootstrapCheckpoints[i]

          if (previousCheckpoint) {
            const elapsed = currentCheckpoint.timestamp - previousCheckpoint.timestamp
            console.debug(`__DRIFT__: Took ${elapsed}ms from [${previousCheckpoint.label}] to [${currentCheckpoint.label}]`)
          }
        }
      }

      const firstCheckpoint = bootstrapCheckpoints[0]
      const lastCheckpoint = bootstrapCheckpoints[bootstrapCheckpoints.length - 1]
      const totalTimeElapsed = lastCheckpoint.timestamp - firstCheckpoint.timestamp

      if (__ENV__ !== 'PRODUCTION') {
        console.debug(`__DRIFT__: (Total Bootstrap Time Elapsed: ${totalTimeElapsed}ms)\n`)
      }

      const metric = createMetric('customer-web.loadTime', {
        type: 'bootstrap.total',
      })

      // NOTE: Sending single bootstrap metric--could dispatch multiple for more granularity into each checkpoint
      return actions.sendDriftAppMetric({
        value: totalTimeElapsed,
        dimensions: {
          path: window.location.pathname,
          type: 'timer',
        },
        metric,
      })
    })

const recordConversationsAppTimer$ = action$ =>
  action$
    .ofType(actions.recordConversationsAppTimer.toString())
    .pluck('payload')
    .map(({ checkpoint, version, elapsed }) => {
      if (__ENV__ !== 'PRODUCTION') {
        console.info(`__DRIFT__: Took ${elapsed}ms from [ConversationsApp.init] to [${checkpoint}]`)
      }

      const metric = createMetric('customer-web.loadTime', {
        app: 'web.conversations',
        appVersion: version,
        type: 'readyForInteraction',
        checkpoint,
      })

      // NOTE: Sending single bootstrap metric--could dispatch multiple for more granularity into each checkpoint
      return actions.sendDriftAppMetric({
        value: elapsed,
        dimensions: {
          type: 'timer',
        },
        metric,
      })
    })

const recordConversationsAppFirstMeaningfulRender$ = action$ =>
  action$
    .ofType(actions.startConversationsAppTimer.toString())
    .switchMap(() => {
      const start = Date.now()

      return action$
        .ofType(actions.hitConversationsAppRenderCheckpoint.toString())
        .pluck('payload')
        .first()
        .map(({ checkpoint, version }) => {
          const elapsed = Date.now() - start
          return actions.recordConversationsAppTimer({ checkpoint, version, elapsed })
        })
    })


export const epic = combineEpics(
  sendDriftAppMetric$,
  countAllActions$,
  dispatchMetricInterval$,
  recordBootstrapPerformance$,
  recordConversationsAppTimer$,
  recordConversationsAppFirstMeaningfulRender$,
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/driftAppMetrics/epic.js